import * as React from "react";
import {Breadcrumbs, Typography, Container, Button, Box, Stack} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useServiceList} from "./hook/useServiceList";
import ServiceItem from "./ServiceItem";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Slider from "react-slick";
import ServiceItemPlaceholder from "./ServiceItemPlaceholder";
import {useState,useEffect} from "react";
import './service.css';
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const Service = ({setShowNav}) => {
    const navigate = useNavigate()
    const {services, serviceOnly, isLoading} = useServiceList();
    const {mode} = useDarkMode();
    useEffect(() => {
        setShowNav(true);
    }, []);

    const settingsServices = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: services.length < 3 ? services.length : 3,
        centerPadding: '-15px',
        centerMode: true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    variableWidth : false,
                    arrows : false,
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    variableWidth : false,
                    centerPadding: '0px',
                },
            }
        ],
        variableWidth : false
    };


    return <Box className="service-container" id="service-list">

            <Box sx={{marginBottom: '20px'}} >
                <Breadcrumbs separator="›" aria-label="breadcrumb" style={{color : mode.settings.textColor3, paddingTop :15}}>
                    {[
                        <Typography  className={'breadcrumbs'} style={{color : mode.settings.breadcrumbColor1}} variant={'body2'} onClick={() => navigate('/')} >
                            Accueil
                        </Typography>,
                        <Typography className={'breadcrumbs'} variant={'body2'} style={{color : mode.settings.textColor3}}>
                            Mes services et conseils
                        </Typography>,
                    ]}
                </Breadcrumbs>
                <Typography
                    variant="h5"
                    sx={{
                        mt: {xs : 2 , md : 2, lg : 2},
                        mb: {xs : 4 , md : 4, lg : 2},
                        textAlign : {xs : 'center' , md : 'center', lg : 'left'},
                    }}
                    style={{color: mode.settings.textColor3}}
                    id={'anchor0'}
                >
                    Mes services et conseils
                </Typography>
                {
                    isLoading && <Stack
                        direction="row"
                        justifyContent="left"
                        alignItems="center"
                        spacing={5}
                    >
                        <ServiceItemPlaceholder/>
                        <ServiceItemPlaceholder/>
                        <ServiceItemPlaceholder/>
                    </Stack>
                }
                    <Slider {...settingsServices}>
                        {
                            !isLoading && services.map( (service, index) => <ServiceItem {...service} key={index}/> )
                        }
                    </Slider>
            </Box>
            <Box className="service-btn-container">
                <Button className="btn">
                    <RemoveRedEyeIcon role={'img'} aria-label="Voir tout" />
                    <Typography variant={'subtitle3'}>Voir tout</Typography>
                </Button>
            </Box>
    </Box>
}

export default Service;
